const env = window.GRAMIT;

export { env };
